module.exports = __webpack_public_path__ + "static/media/star.b55f122c.svg";